/**
 * @fileoverview GET handler for the "/engagement/recommender_analytics" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementRecommenderAnalytics } from "./constants";
import type { EngagementRecommenderAnalyticsResult } from "./types";

export const getEngagementRecommenderAnalytics = reactQueryFetcherAdapter(
  engagementRecommenderAnalytics,
  (signal: AbortSignal, recommenderId: string): Promise<EngagementRecommenderAnalyticsResult> => {
    return fetch("/engagement/recommender_analytics", "GET", { recommender_id: recommenderId }, { signal });
  }
);
